export default __webpack_public_path__ + "static/media/el2.af87faf3.png";